import { nil, PartialRootPropertyUpdateTree } from "@animech/axiom-format";
import { transformValue } from "@animech/axiom-utility";
import { serializedNil, serializedUndefined, SessionData } from "./types";
import { Root } from "@definitions";
import { migrateToLatest } from "src/core/configuration-migrations/migration";

export const _migrateAndDeserialize = (sessionData: SessionData) => {
	const migrated = migrateToLatest(sessionData);
	return _deserializeConfiguration(migrated.configurationDelta);
};

export const _deserializeConfiguration = (
	configuration: PartialRootPropertyUpdateTree<Root>,
) => {
	return transformValue(configuration, (value) =>
		value === serializedUndefined
			? { replace: undefined }
			: value === serializedNil
				? { replace: nil }
				: undefined,
	);
};
